import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { OOI_EXPERIMENTS } from '@app/experiments';
import { TooltipPortalProvider } from '../../context/tooltip-context';
import AppWrapper from '../app-wrapper';
import { type AppProps } from './app-props';
import styles from './app.scss';

type PropsMobile = {
  mobileHeader?: React.FunctionComponentElement<{ menu?: React.FunctionComponentElement<any> }>;
};

const AppMobile: React.FC<AppProps & PropsMobile> = ({
  main,
  messageRoot,
  mobileHeader,
  modalRoot,
  popoverRoot,
}) => {
  const { isEditor } = useEnvironment();
  const { experiments } = useExperiments();

  useEffect(() => {
    if (!experiments.enabled(OOI_EXPERIMENTS.REMOVE_ENABLE_SCROLL) && !isEditor) {
      document.documentElement.classList.add('enable-scroll');
    }
  }, [isEditor, experiments]);

  return (
    <AppWrapper className={classNames(styles.app, 'app-mobile', 'blog-background-color')}>
      <TooltipPortalProvider>
        {messageRoot}
        {modalRoot}
        {popoverRoot}
        <div id="content-wrapper">
          {mobileHeader}
          {main}
        </div>
      </TooltipPortalProvider>
    </AppWrapper>
  );
};

export default AppMobile;
